import 'whatwg-fetch';

import { AccessTokenManager } from '@spotify-internal/access-token';
import {
  accessTokenManager,
  defaultWebgateHeaders,
} from '@mrkt/features/webgate-fetch';
import { CLIENT_ID_S4A_ONBOARDING } from './constants_DEPRECATED';
import { toJSON, verifyResponse, API } from './helpers';

export * from './constants_DEPRECATED';
export {
  accessTokenManager,
  webgateFetch,
  webgateFetchJson,
} from '@mrkt/features/webgate-fetch';

export const anonymousAccessTokenManager = AccessTokenManager.createAnonymous(
  CLIENT_ID_S4A_ONBOARDING,
);

const mapResponse = response => toJSON(verifyResponse(response));

// DO NOT USE THIS! USE webgateFetch instead!
export const webgate = new API({
  defaultHeaders: defaultWebgateHeaders,
  getAccessToken: accessTokenManager.get.bind(accessTokenManager),
  mapResponse,
});

export const webgateAnonymous = new API({
  defaultHeaders: defaultWebgateHeaders,
  getAccessToken: anonymousAccessTokenManager.get.bind(
    anonymousAccessTokenManager,
  ),
  mapResponse,
});

// DO NOT USE THIS! USE webgateFetch instead!
export const webapi = new API({
  baseUrl: 'https://api.spotify.com',
  getAccessToken: accessTokenManager.get.bind(accessTokenManager),
  mapResponse,
});

export const webapiAnonymous = new API({
  baseUrl: 'https://api.spotify.com',
  getAccessToken: anonymousAccessTokenManager.get.bind(
    anonymousAccessTokenManager,
  ),
  mapResponse,
});

// export legacy helpers
const { request, get, post, put, patch, delete: del } = webgate;
export { request, get, post, put, patch, del };

export async function webapiFetch(url, options = {}) {
  const token = await accessTokenManager.get();

  return fetch(url, {
    ...options,
    credentials: 'same-origin',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      ...options.headers,
      authorization: `Bearer ${token}`,
    },
  });
}
